import { useMemo } from 'react';
import { OneBallotResourceType } from '../resources/Ballot/One';
import { getCompleteCategoryKeys } from '../resources/Ballot/services';
import ObjectiveStateResource from '../resources/ObjectiveState';
import PreviousYearResultOrderResource from '../resources/ObjectiveState/PreviousYearResultOrder';
import useCopy from '../util/useCopy';
import ballotDisplayOrder from '../resources/Ballot/constants/ballotDisplayOrder';
import { getSortedCategoryKeys, FINAL_STRETCH_THRESHOLD } from '../util/getSortedCategoryKeys';
import { BallotPreviewItem } from './BallotPreviewItem';

// TODO: remove after 2026 — Live Action Short tie override
let LIVE_ACTION_SHORT_TIE_CATEGORY = 'bestLiveActionShort';

export let BallotPreview = ({
  ballot,
  userHandle,
  showScore,
}: {
  ballot: OneBallotResourceType;
  userHandle: string;
  showScore?: boolean;
}) => {
  let copy = useCopy();
  let objectiveState = ObjectiveStateResource.use();
  let previousYearResultOrder = PreviousYearResultOrderResource.use();

  let { announced, unannounced } = useMemo(
    () =>
      getSortedCategoryKeys({
        keys: getCompleteCategoryKeys({
          ballot,
          ballotShape: objectiveState.ballotShape,
        }),
        objectiveState,
        previousYearResultOrder,
      }),
    [ballot, objectiveState, previousYearResultOrder],
  );

  if (ballot === null)
    return (
      <div className="px-6 pt-4 pb-6">
        {userHandle} {copy.hasntStartedTheirBallot}.
      </div>
    );

  let renderItem = (ballotItemKey: (typeof ballotDisplayOrder)[number]) => {
    let { displayName, options } =
      objectiveState.ballotShape[ballotItemKey];
    let selectedOption = options[ballot[ballotItemKey]];

    // TODO: remove after 2026 — Live Action Short tie override
    let label = ballotItemKey === LIVE_ACTION_SHORT_TIE_CATEGORY
      ? `${displayName} (Tie)`
      : displayName;

    return (
      <BallotPreviewItem
        key={ballotItemKey}
        ballotItemDisplayName={label}
        selectedOption={selectedOption}
        showScore={showScore}
      />
    );
  };

  return (
    <div className="px-6 pt-4 pb-6">
      {unannounced.length <= FINAL_STRETCH_THRESHOLD ? (
        <>
          {unannounced.map(renderItem)}
          {announced.length > 0 && unannounced.length > 0 && (
            <hr className="my-4 border-t-4 border-neutral-100" />
          )}
          {announced.map(renderItem)}
        </>
      ) : (
        <>
          {announced.map(renderItem)}
          {announced.length > 0 && unannounced.length > 0 && (
            <hr className="my-4 border-t-4 border-neutral-100" />
          )}
          {unannounced.map(renderItem)}
        </>
      )}
    </div>
  );
};
